import React from 'react';
import PropTypes from 'prop-types';

import { BaseButton } from '../base-button';
import styles from './PrimaryButton.css';

const IPropTypes = {
  className: PropTypes.string,
};

const defaultProps = {
  className: '',
};

const PrimaryButton = props => (
  <BaseButton
    {...props}
    className={[styles.container, props.className].join(' ')}
    disabledClassName={styles.disabled}
    pressedClassName={styles.pressed}
  />
);

PrimaryButton.propTypes = IPropTypes;
PrimaryButton.defaultProps = defaultProps;

export { PrimaryButton };



// WEBPACK FOOTER //
// ./src/common/primary-button/PrimaryButton.jsx